import React, { useState } from "react";
import "../styles/strategy_pick_card.css";

export default function StrategyPickCard({
    strategyId,
    picks,
    setPicks,
    onDeleteUpdateId,
    odds,
    stake,
    result,
    created_at,
    addToast
}) {
    const [editOpen, setEditOpen] = useState(false); // <-- csak a lenyíló részhez

    const borderColor =
        result === "win"
            ? "#28a745"
            : result === "lose"
                ? "#dc3545"
                : "#6c757d";

    const resultColor =
        result === "win"
            ? "text-success"
            : result === "lose"
                ? "text-danger"
                : "text-secondary";


    const handleResultSave = (newResult) => {
        const newList = picks.map(p =>
            p.id === onDeleteUpdateId ? { ...p, result: newResult } : p
        )
        setPicks(newList);

        fetch(`https://focifanatik.hu/api/update_strategy_pick.php?id=${onDeleteUpdateId}`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ result: newResult }),
            credentials: "include"
        })
            .then(res => res.json())
            .then(data => {
                if (data.success) {
                    addToast("Eredmény frissítve!", "success");

                } else {
                    addToast("Hiba mentéskor!", "warning");
                }
            })
            .catch(err => {
                console.error(err);
                addToast("Hálózati hiba!", "warning");
            });
    }


    const handleDelete = (id) => {

        fetch(`https://focifanatik.hu/api/delete_strategy_pick.php?id=${id}`, {
            method: "DELETE",
            credentials: "include"
        })
            .then(res => res.json())
            .then(data => {
                if (data.success) {
                    addToast("Sikeres törlés!", "success");
                    setPicks(picks.filter(pick => pick.id !== id));

                    fetch(`https://focifanatik.hu/api/get_strategy_picks.php?id=${strategyId}`)
                        .then(r => r.json())
                        .then(d => setPicks(d));
                } else {
                    addToast("Hiba!", "warning");
                }
            })
            .catch(err => console.error("Hálózati hiba:", err));
    };

    const maxwin = (odds * stake).toFixed(2);

    return (
        <div
            className="strategy-pick-card"
            style={{ borderColor }}
        >
            {/* FEJLÉC */}
            <div className="spc-header">
                <div></div>
                <span>{Number(stake).toLocaleString("hu-HU")} Ft</span>
                <small>{new Date(created_at).toLocaleDateString("hu-HU")}</small>
            </div>

            {/* KÖZÉPSŐ BLOKK */}
            <div className="spc-middle">
                <div className="spc-box">
                    <div className="spc-label">Odds</div>
                    <div className="spc-value">{odds}</div>
                </div>

                <div className="spc-box">
                    <div className="spc-label">Eredmény</div>
                    <div className={`spc-value ${resultColor}`}>
                        {result === "win"
                            ? "Nyertes"
                            : result === "lose"
                                ? "Vesztes"
                                : "Függőben"}
                    </div>
                </div>
            </div>

            {/* NYEREMÉNY */}
            <div className="spc-win">
                {Number(maxwin).toLocaleString("hu-HU")} Ft
            </div>

            {/* AKCIÓK */}
            <div className="spc-actions">
                <button
                    className="spc-btn"
                    onClick={() => setEditOpen(v => !v)}
                >
                    Szerkeszt
                </button>

                <button
                    className="spc-btn danger"
                    onClick={() => handleDelete(onDeleteUpdateId)}
                >
                    ✕
                </button>
            </div>

            {/* LENYÍLÓ SZERKESZTÉS */}
            {editOpen && (
                <div className="spc-edit">
                    <button onClick={() => handleResultSave("pending")}>Függőben</button>
                    <button onClick={() => handleResultSave("win")}>Nyertes</button>
                    <button onClick={() => handleResultSave("lose")}>Vesztes</button>
                </div>
            )}
        </div>
    );
}
